/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategoryRefDto } from '../models/category-ref-dto';
import { PagedCategorySearchResultDto } from '../models/paged-category-search-result-dto';
import { PagedProductSearchResultDto } from '../models/paged-product-search-result-dto';
import { PagedVendorSearchResultDto } from '../models/paged-vendor-search-result-dto';
import { ProductRefDto } from '../models/product-ref-dto';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchCategories
   */
  static readonly SearchCategoriesPath = '/search/categories';

  /**
   * Search for categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCategories()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  searchCategories$Response(params?: {
    search?: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<CategoryRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SearchService.SearchCategoriesPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategoryRefDto>>;
      })
    );
  }

  /**
   * Search for categories.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  searchCategories(params?: {
    search?: string;
    limit?: number;
  }): Observable<Array<CategoryRefDto>> {

    return this.searchCategories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategoryRefDto>>) => r.body as Array<CategoryRefDto>)
    );
  }

  /**
   * Path part for operation searchCategoriesPaged
   */
  static readonly SearchCategoriesPagedPath = '/search/categories/paged';

  /**
   * Search for categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCategoriesPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchCategoriesPaged$Response(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedCategorySearchResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, SearchService.SearchCategoriesPagedPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedCategorySearchResultDto>;
      })
    );
  }

  /**
   * Search for categories.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchCategoriesPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchCategoriesPaged(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<PagedCategorySearchResultDto> {

    return this.searchCategoriesPaged$Response(params).pipe(
      map((r: StrictHttpResponse<PagedCategorySearchResultDto>) => r.body as PagedCategorySearchResultDto)
    );
  }

  /**
   * Path part for operation searchProducts
   */
  static readonly SearchProductsPath = '/search/products';

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProducts()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  searchProducts$Response(params?: {
    search?: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<ProductRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SearchService.SearchProductsPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductRefDto>>;
      })
    );
  }

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  searchProducts(params?: {
    search?: string;
    limit?: number;
  }): Observable<Array<ProductRefDto>> {

    return this.searchProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductRefDto>>) => r.body as Array<ProductRefDto>)
    );
  }

  /**
   * Path part for operation searchProductsPaged
   */
  static readonly SearchProductsPagedPath = '/search/products/paged';

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProductsPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged$Response(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedProductSearchResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, SearchService.SearchProductsPagedPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedProductSearchResultDto>;
      })
    );
  }

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchProductsPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<PagedProductSearchResultDto> {

    return this.searchProductsPaged$Response(params).pipe(
      map((r: StrictHttpResponse<PagedProductSearchResultDto>) => r.body as PagedProductSearchResultDto)
    );
  }

  /**
   * Path part for operation searchVendorsPaged
   */
  static readonly SearchVendorsPagedPath = '/search/vendors/paged';

  /**
   * Search for vendors.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchVendorsPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVendorsPaged$Response(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedVendorSearchResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, SearchService.SearchVendorsPagedPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedVendorSearchResultDto>;
      })
    );
  }

  /**
   * Search for vendors.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchVendorsPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVendorsPaged(params: {
    search?: string;
    pageIndex?: number;
    pageSize: number;
  }): Observable<PagedVendorSearchResultDto> {

    return this.searchVendorsPaged$Response(params).pipe(
      map((r: StrictHttpResponse<PagedVendorSearchResultDto>) => r.body as PagedVendorSearchResultDto)
    );
  }

}
